import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObject4Route: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object',
	path: '/jira/servicedesk/insight/assets/:objectId',
};
